(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fabdeal-hero-slider"] && !Shopify.designMode) return;
  try {
    

(function () {

  function init(root) {

    if (
      !root ||
      root.dataset.fabdealReady === "true"
    ) {
      return;
    }

    root.dataset.fabdealReady = "true";


    var slides =
      root.querySelectorAll(
        ".fabdeal-slide"
      );


    if (slides.length < 2) {
      return;
    }


    var dots =
      root.querySelectorAll(
        ".fabdeal-dot"
      );


    var next =
      root.querySelector(
        ".fabdeal-next"
      );


    var prev =
      root.querySelector(
        ".fabdeal-prev"
      );


    var pause =
      root.querySelector(
        ".fabdeal-pause"
      );


    var slider =
      root.querySelector(
        ".fabdeal-slider"
      );


    var ms =
      parseInt(
        root.dataset.autoplayMs,
        10
      ) || 5000;


    var auto =
      root.dataset.autoplay === "true";


    /*
     * Shopify Theme Editor can re-render this section whenever a setting
     * changes. Preserve the currently visible slide across those re-renders.
     *
     * The index is stored on the root element and also on a body-level
     * temporary store so it survives replacement of the section's DOM.
     */
    var current = 0;

    var editorStateKey =
      "fabdeal-slider-" + (root.id || "default");

    var userPaused = false;

    var inView = true;

    var visible =
      document.visibilityState !== "hidden";

    var timer = null;


    var sx = 0;

    var sy = 0;

    var st = 0;


    /* =====================================================
       LOAD IMAGE ONLY WHEN NEEDED
       ===================================================== */

    function load(i) {

      var slide =
        slides[i];

      if (!slide) {
        return;
      }


      var img =
        slide.querySelector(
          ".fabdeal-full-image"
        );


      if (!img) {
        return;
      }


      /*
        Deferred slides have no src.
        We only assign it when needed.
      */

      if (
        !img.getAttribute("src") &&
        img.dataset.src
      ) {

        /*
          Create the tiny LQIP now.
        */

        var lq =
          document.createElement("img");


        lq.className =
          "fabdeal-lqip";


        lq.src =
          img.dataset.lqip || "";


        lq.alt = "";


        lq.setAttribute(
          "aria-hidden",
          "true"
        );


        lq.loading =
          "lazy";


        lq.decoding =
          "async";


        lq.width = 120;

        lq.height = 120;


        img.parentNode.insertBefore(
          lq,
          img
        );


        /*
          Start full image request.
        */

        img.src =
          img.dataset.src;


        if (img.dataset.srcset) {

          img.srcset =
            img.dataset.srcset;

        }

      }


      var lqip =
        slide.querySelector(
          ".fabdeal-lqip"
        );


      /*
        Hide the blurred placeholder
        once the full image is ready.
      */

      function done() {

        if (lqip) {

          lqip.classList.add(
            "fabdeal-hide"
          );

        }

      }


      if (
        img.complete &&
        img.naturalWidth
      ) {

        done();

      } else {

        img.addEventListener(
          "load",
          done,
          {
            once: true
          }
        );

      }

    }


    /* =====================================================
       SHOW SLIDE
       ===================================================== */

    function show(i) {

      current =
        (i + slides.length) %
        slides.length;

      /*
       * Save the active slide before/after every navigation action.
       * This is especially important in the Shopify Theme Editor.
       */
      root.dataset.fabdealCurrentSlide = String(current);

      if (window.Shopify && window.Shopify.designMode) {
        try {
          window.__fabdealSliderState =
            window.__fabdealSliderState || {};

          window.__fabdealSliderState[editorStateKey] =
            current;
        } catch (e) {
          /* Ignore storage errors in Theme Editor. */
        }
      }


      slides.forEach(
        function (slide, n) {

          slide.classList.toggle(
            "active",
            n === current
          );

        }
      );


      dots.forEach(
        function (dot, n) {

          dot.classList.toggle(
            "active",
            n === current
          );

        }
      );


      /*
        IMPORTANT:
        Only current slide image loads.
      */

      load(current);

    }


    /* =====================================================
       AUTOPLAY
       ===================================================== */

    function schedule() {

      if (timer) {

        clearTimeout(timer);

        timer = null;

      }


      if (
        auto &&
        !userPaused &&
        inView &&
        visible
      ) {

        timer =
          setTimeout(
            function () {

              show(
                current + 1
              );

              schedule();

            },
            ms
          );

      }

    }


    /* =====================================================
       NEXT
       ===================================================== */

    if (next) {

      next.addEventListener(
        "click",
        function () {

          show(
            current + 1
          );

          schedule();

        }
      );

    }


    /* =====================================================
       PREVIOUS
       ===================================================== */

    if (prev) {

      prev.addEventListener(
        "click",
        function () {

          show(
            current - 1
          );

          schedule();

        }
      );

    }


    /* =====================================================
       DOTS
       ===================================================== */

    dots.forEach(
      function (dot, i) {

        dot.addEventListener(
          "click",
          function () {

            show(i);

            schedule();

          }
        );

      }
    );


    /* =====================================================
       PAUSE / PLAY
       ===================================================== */

    if (pause) {

      pause.addEventListener(
        "click",
        function () {

          userPaused =
            !userPaused;


          pause.textContent =
            userPaused
              ? "▶"
              : "Ⅱ";


          pause.setAttribute(
            "aria-pressed",
            userPaused
              ? "true"
              : "false"
          );


          pause.setAttribute(
            "aria-label",
            userPaused
              ? "Play automatic slideshow"
              : "Pause automatic slideshow"
          );


          schedule();

        }
      );

    }


    /* =====================================================
       MOBILE SWIPE
       ===================================================== */

    if (slider) {

      slider.addEventListener(
        "touchstart",
        function (e) {

          if (
            e.touches.length
          ) {

            sx =
              e.touches[0].clientX;

            sy =
              e.touches[0].clientY;

            st =
              Date.now();

          }

        },
        {
          passive: true
        }
      );


      slider.addEventListener(
        "touchend",
        function (e) {

          if (
            !e.changedTouches.length
          ) {
            return;
          }


          var dx =
            e.changedTouches[0].clientX -
            sx;


          var dy =
            e.changedTouches[0].clientY -
            sy;


          var duration =
            Date.now() - st;


          if (
            duration <= 800 &&
            Math.abs(dx) >= 45 &&
            Math.abs(dx) >
              Math.abs(dy) * 1.2
          ) {

            show(
              dx < 0
                ? current + 1
                : current - 1
            );


            schedule();

          }

        },
        {
          passive: true
        }
      );

    }


    /* =====================================================
       INTERSECTION OBSERVER
       ===================================================== */

    if (
      "IntersectionObserver" in window
    ) {

      var observer =
        new IntersectionObserver(
          function (entries) {

            entries.forEach(
              function (entry) {

                if (
                  entry.target === root
                ) {

                  inView =
                    entry.isIntersecting;

                  schedule();

                }

              }
            );

          },
          {
            threshold: 0.1
          }
        );


      observer.observe(root);

    }


    /* =====================================================
       TAB VISIBILITY
       ===================================================== */

    document.addEventListener(
      "visibilitychange",
      function () {

        visible =
          document.visibilityState !==
          "hidden";

        schedule();

      }
    );


    /* =====================================================
       INITIALIZE
       ===================================================== */

    /*
     * In the Shopify Theme Editor, section settings cause the section DOM
     * to be replaced. Restore the slide that was visible before that
     * replacement instead of always jumping back to slide 1.
     *
     * On a normal storefront page we intentionally start at slide 1.
     */
    var initialSlide = 0;

    if (window.Shopify && window.Shopify.designMode) {
      try {
        window.__fabdealSliderState =
          window.__fabdealSliderState || {};

        var savedSlide =
          window.__fabdealSliderState[editorStateKey];

        if (
          typeof savedSlide === "number" &&
          savedSlide >= 0 &&
          savedSlide < slides.length
        ) {
          initialSlide = savedSlide;
        }
      } catch (e) {
        initialSlide = 0;
      }
    }

    show(initialSlide);

    schedule();

  }


  /* =======================================================
     INITIAL PAGE LOAD
     ======================================================= */

  function all() {

    document
      .querySelectorAll(
        ".fabdeal-hero"
      )
      .forEach(init);

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      all
    );

  } else {

    all();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
     ======================================================= */

  /*
   * Shopify Theme Editor:
   * Keep the slider's active slide when the section is reloaded.
   */
  document.addEventListener(
    "shopify:section:unload",
    function (event) {
      var root =
        event.target.querySelector
          ? event.target.querySelector(".fabdeal-hero")
          : null;

      if (root && root.dataset.fabdealCurrentSlide) {
        try {
          window.__fabdealSliderState =
            window.__fabdealSliderState || {};

          window.__fabdealSliderState[
            "fabdeal-slider-" + (root.id || "default")
          ] =
            parseInt(
              root.dataset.fabdealCurrentSlide,
              10
            ) || 0;
        } catch (e) {
          /* Ignore Theme Editor state errors. */
        }
      }
    }
  );

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      var root =
        event.target.querySelector(
          ".fabdeal-hero"
        );


      if (root) {

        init(root);

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ia-section-announcement-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const marq = document.getElementById('ia-sections-marq');
    const orig = document.getElementById('ia-sections-orig');
    const clone = orig.cloneNode(true);
    clone.id = 'ia-sections-clone';
    marq.appendChild(clone);
  });

  } catch(e) { console.error(e); }
})();
})();
